import React from 'react';
import { Redirect } from 'react-router-dom';
import { Permissions } from '../../../shared/auth/constants/permissions';
import { useHasOneOfPermissions } from '../../Session';
import BasicLayout from '../../layouts/BasicLayout';
import SaleTransactions from '../../pages/SaleTransactions';
import { DownloadSalesTransactionsFileProvider } from '../../pages/SaleTransactions/components';

const SaleTransactionsRoute = () => {
    const canViewTransactions = useHasOneOfPermissions([
        Permissions.SALES_TRANSACTION_VIEW_ALL_TRANSACTIONS,
        Permissions.SALES_TRANSACTION_VIEW_MY_TRANSACTIONS,
    ]);

    if (canViewTransactions) {
        return (
            <BasicLayout>
                <DownloadSalesTransactionsFileProvider>
                    {downloadFile => <SaleTransactions downloadSalesTransactionsFile={downloadFile} />}
                </DownloadSalesTransactionsFileProvider>
            </BasicLayout>
        );
    }

    return <Redirect to="/403" />;
};

export default SaleTransactionsRoute;
